import { datadogRum } from '@datadog/browser-rum'
import { RemoveProductParams } from '../redux/slices/cart/types'
import { setSynchronizingCart } from '../redux/slices/catalog'
import { setSkuSyncing } from '../redux/skuSyncing'
import { generateDataDogContext } from './dataDog'
import { armCartMutationTimeout } from './cartMutationTimeout'

const onRemoveProduct = async ({
  sessionId,
  storeName,
  removeProductFunction,
  sku,
  quantity,
  dispatch,
  referrer,
  controller,
  subItems,
  replace,
  packageName,
  disableWhileSyncing,
}: RemoveProductParams) => {
  let disarmTimeout: (() => void) | undefined
  try {
    dispatch(setSynchronizingCart(true))
    if (disableWhileSyncing) {
      dispatch(setSkuSyncing({ sku, isSyncing: true }))
      // A request that never answers would leave the marked rows disabled.
      if (controller) {
        disarmTimeout = armCartMutationTimeout(controller)
      }
    }

    await removeProductFunction({
      variables: {
        cartRemoveProductSessionUid: sessionId,
        cartRemoveProductStorefrontName: storeName,
        cartRemoveProductData: {
          sku,
          quantity,
          replace,
          referrer: referrer || undefined,
          subItems,
          package: packageName,
        },
      },
      context: { fetchOptions: { signal: controller?.signal } },
    })
  } catch (error) {
    const context = generateDataDogContext({
      title: 'could not remove product from cart',
      extraInfo: { sku, quantity, function: 'onRemoveProduct' },
    })
    datadogRum.startView(context.viewName)
    datadogRum.addError(error, context)
  } finally {
    disarmTimeout?.()
    dispatch(setSynchronizingCart(false))
    if (disableWhileSyncing) {
      dispatch(setSkuSyncing({ sku, isSyncing: false }))
    }
  }
}

export default onRemoveProduct
